var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0V0C31.0457 0 40 8.95431 40 20V20C40 31.0457 31.0457 40 20 40V40C8.95431 40 0 31.0457 0 20V20Z",
    fill: "#CDD9DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 14C11.3358 14 11 14.3358 11 14.75C11 15.1642 11.3358 15.5 11.75 15.5H27.8882C28.3024 15.5 28.6382 15.1642 28.6382 14.75C28.6382 14.3358 28.3024 14 27.8882 14H11.75ZM11.0004 19.7157C11.0004 19.3015 11.3362 18.9657 11.7504 18.9657H27.8886C28.3028 18.9657 28.6386 19.3015 28.6386 19.7157C28.6386 20.13 28.3028 20.4657 27.8886 20.4657H11.7504C11.3362 20.4657 11.0004 20.13 11.0004 19.7157ZM11.0004 24.6815C11.0004 24.2673 11.3362 23.9315 11.7504 23.9315H27.8886C28.3028 23.9315 28.6386 24.2673 28.6386 24.6815C28.6386 25.0957 28.3028 25.4315 27.8886 25.4315H11.7504C11.3362 25.4315 11.0004 25.0957 11.0004 24.6815Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMenu);
export default __webpack_public_path__ + "static/media/open-menu.46e5e5910d62d5b527e70ff0c48e0505.svg";
export { ForwardRef as ReactComponent };